import React from 'react';
import ProjectsPage from './ProjectsPage'
export default () => (<ProjectsPage statusFilter={3} />)